import PageToolbar from '../../../Shared/PageToolbar'
import Row from '../../../Shared/GridGM'
import Col from '../../../Shared/GridGM/Col'
import Input from '../../../Shared/Form/Input'
import Select from '../../../Shared/Form/Select'
import Button from '../../../Shared/Form/Button'
import { Trans, useTranslation } from 'react-i18next'
import Table from '../../../Shared/Table'
import TableRow from '../../../Shared/Table/TableRow'
import TableHead from '../../../Shared/Table/TableHead'
import React from 'react'
import CompareHotel from '../../../Shared/Hotel/compareHotel'
import { constants } from '../../../../constants'

const CompareSearch = ({
                         onFormSubmit,
                         onQueryChange,
                         onDistanceChange,
                         onSearchClick,
                         query,
                         distance,
                         distanceOptions,
                         foundHotels,
                         item,
                         compare,
                         onAddCompare,
                         onRemoveCompare
                       }) => {
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <PageToolbar>
        <form onSubmit={onFormSubmit}>
          <Row grid="8">
            <Col cols="5">
              <Input name="search" placeholder={t('LABEL_SEARCH')} value={query ?? ''}
                     onChange={onQueryChange}/>
            </Col>
            <Col cols="2">
              <Select type="default" options={distanceOptions} onChange={onDistanceChange} selected={distance}/>
            </Col>
            <Col cols="1">
              <Button align="right" classNames="Button-Full"
                      onClick={onSearchClick}><Trans>BUTTON_SEARCH</Trans></Button>
            </Col>
          </Row>
        </form>
      </PageToolbar>
      <div className="container">
        <Table className="TableMyHotels">
          <TableRow className="Gradient">
            <TableHead width="1"><Trans>TABLE_HEAD_HOTEL_NAME</Trans></TableHead>
            <TableHead></TableHead>
            <TableHead><Trans>TABLE_HEAD_RATING</Trans></TableHead>
            <TableHead width="140"><Trans>TABLE_HEAD_OVERALL_SCORE</Trans></TableHead>
            <TableHead></TableHead>
            <TableHead><Trans>TABLE_HEAD_COMPARE</Trans></TableHead>
          </TableRow>
          {foundHotels.items !== undefined &&
            <React.Fragment>
              {foundHotels.items.map((hotel) => {
                let compareHotel = {
                  items: [hotel],
                  related: foundHotels.related
                }
                return (
                  <CompareHotel
                    key={hotel.id}
                    item={compareHotel} activeHotel={item} compare={compare}
                    onAddCompare={onAddCompare} onRemoveCompare={onRemoveCompare}
                  />
                )
              })}
            </React.Fragment>
          }
        </Table>
        <div className="ScoreLegend">
          {constants.scores.seq.map((scoreId) => {
            let type = constants.scores.types[scoreId]
            return (
              <div key={scoreId} className="ScoreLegendItem"><span className={'Score-Bar-' + scoreId}></span>
                <Trans>{type.name}</Trans></div>
            )
          })}
        </div>
      </div>
    </React.Fragment>
  )
}

export default CompareSearch
